import type React from 'react';

interface JoinViewProps {
  meetingId: string;
  onSignIn: () => void;
  onContinueAsGuest: () => void;
}

export const JoinView: React.FC<JoinViewProps> = ({ meetingId, onSignIn, onContinueAsGuest }) => (
  <>
    <h1 id="sign-in-required-title" className="sign-in-required__title">
      Join meeting
    </h1>
    <p className="sign-in-required__meeting-id">Meeting ID: {meetingId}</p>
    <p className="sign-in-required__description">
      Please sign in to proceed to the meeting or continue as guest.
    </p>
    <div className="sign-in-required__actions">
      <button
        type="button"
        onClick={onSignIn}
        className="sign-in-required__button sign-in-required__button--primary"
      >
        Sign In
      </button>
      <button
        type="button"
        onClick={onContinueAsGuest}
        className="sign-in-required__button sign-in-required__button--text"
      >
        Continue as Guest
      </button>
    </div>
  </>
);
